import * as t from '../types';
import {GET_QUIZ_QUESTION_REQUEST} from "../types";

const initialState = {
    data: '',
    loading: false,
    error: '',
};

export default function quizQuestionReducer(state = initialState, action) {
    const {type, payload} = action;
    switch (type) {
        case t.GET_QUIZ_QUESTION_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case t.GET_QUIZ_QUESTION_SUCCESS:
            return {
                ...state,
                loading: false,
                data: payload.data,
            };
        case t.GET_QUIZ_QUESTION_FAILED:
            return {
                ...state,
                error: payload,
                loading: false,
            };
        default:
            return state;
    }
}
